module.exports = __webpack_public_path__ + "img/strengths-image2.0fd30cd5.svg";